module.exports = __webpack_public_path__ + "static/guide.538b3c61.png";